import { render } from "./padel-textarea.template.html?vue&type=template&id=4bbc1965&scoped=true"
import script from "./PadelTextarea.vue?vue&type=script&lang=ts"
export * from "./PadelTextarea.vue?vue&type=script&lang=ts"

import "./PadelTextarea.vue?vue&type=style&index=0&id=4bbc1965&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4bbc1965"

export default script